import { mainColor } from "assets/styleUtils";
import * as React from "react";

const Svg = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M10.4004 4.66675V16.3334"
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M4.56641 10.5H16.2331"
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default Svg;
